// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2gshi","rightAdornment":"Header_rightAdornment__3Hudj"};